import * as React from 'react'

import ApolloProvider from './Apollo'
import ReactQueryProvider from './ReactQuery'
import { AuthProvider } from './Auth'
import { GlobalMessageProvider } from './GlobalMessage'
import { ListFilterProvider } from './ListFilter'
import { SubscriptionProvider } from './SubscriptionContext'
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3'
import { ThemeProvider } from './Theme'

type Props = {
  children?: React.ReactNode
}

export const AppProvider: React.FC<Props> = ({ children }) => (
  <ThemeProvider>
    <GoogleReCaptchaProvider
      reCaptchaKey={process.env.GATSBY_GOOGLE_RECAPTCHA_SITE_KEY || ''}
      scriptProps={{ async: true, defer: true }}
    >
      <ReactQueryProvider>
        <ApolloProvider>
          <AuthProvider>
            <SubscriptionProvider>
              <ListFilterProvider>
                <GlobalMessageProvider>
                  { children }
                </GlobalMessageProvider>
              </ListFilterProvider>
            </SubscriptionProvider>
          </AuthProvider>
        </ApolloProvider>
      </ReactQueryProvider>
    </GoogleReCaptchaProvider>
  </ThemeProvider>
)
